import { ACTION } from './vrf_system_actions';
import makeCrudReducer from './make_crud_reducer';

export default makeCrudReducer(ACTION);



// WEBPACK FOOTER //
// ./src/redux/vrf/vrf_system_reducer.js